exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".src-components-Landing-Pricing-___style__banner___15otn{height:80px;background-image:url(/img/landing/banner-bg.jpg);background-position:top center;background-repeat:no-repeat;background-size:cover}@media screen and (max-width: 991px){.src-components-Landing-Pricing-___style__banner___15otn{height:70px}}\n", ""]);

// Exports
exports.locals = {
	"banner": "src-components-Landing-Pricing-___style__banner___15otn"
};